import styles from "./CoachMePromo.module.scss";
import { FormattedMessage, useIntl } from "react-intl";
import bookshelfImg from "./img/bookshelf.png";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";

export default function CoachMePromo({ className }: { className?: string }) {
  const intl = useIntl();

  return (
    <div className={clsx(styles.coachMe, className)}>
      <div className={styles.coachMeOverlay}>
        <h3 className={styles.coachMeTitle}>
          <FormattedMessage
            defaultMessage="<img></img> + CoachMe"
            values={{
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              img: () => <img src={bookshelfImg} alt="Bookshelf" />,
            }}
          />
        </h3>
        <div className={styles.coachMeMainText}>
          <FormattedMessage defaultMessage="Studying Just Got a Whole Lot Easier with Bookshelf® CoachMe™" />
        </div>
        <BaseLinkOrButton
          className={clsx(
            "vst-button-pill",
            "vst-button-variant-white-outline",
            styles.coachMeLearnMore
          )}
          aria-label={intl.formatMessage({
            defaultMessage: "Learn More About Bookshelf CoachMe",
          })}
          // No localization at this time
          href="https://get.vitalsource.com/what-we-offer/bookshelf-coachme"
        >
          <FormattedMessage defaultMessage="Learn More" />
        </BaseLinkOrButton>
      </div>
    </div>
  );
}
